import { render, staticRenderFns } from "./To-dos.vue?vue&type=template&id=54dc8bb4&scoped=true&"
import script from "./To-dos.vue?vue&type=script&lang=js&"
export * from "./To-dos.vue?vue&type=script&lang=js&"
import style0 from "./To-dos.vue?vue&type=style&index=0&id=54dc8bb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc8bb4",
  null
  
)

export default component.exports